import React from "react"
import { graphql } from "gatsby"
import { Container, Row, Col } from "reactstrap"

import { compose, head, prop } from "ramda"
import { getEdgesForQuery, getQueryData, getSectionDataFor } from "@utils/utils"

import "./PositionDetail.scss"

/**
 * import Sections
 */
import MainLayout from "@layouts/MainLayout/MainLayout"
import HeaderSection from "@components/shared/HeaderSection/HeaderSection"
import ContactSection from "@components/shared/ContactSection/ContactSection"

import imageCareers from "@assets/pictures/buehne_jobs.svg"

/**
 * quering data
 */
export const query = graphql`
  query PositionDetailQuery($slug: String) {
    content: allMarkdownRemark(
      filter: {
        frontmatter: {
          path: { eq: "/careers" }
          published: { eq: true }
          lang: { eq: "de" }
        }
      }
    ) {
      edges {
        node {
          frontmatter {
            path
            subtitle
            title
            section
          }
          internal {
            content
          }
        }
      }
    }
    positionDetails: allMarkdownRemark(
      filter: {
        frontmatter: {
          path: { eq: "/positions" }
          published: { eq: true }
          lang: { eq: "de" }
          slug: { eq: $slug }
        }
      }
    ) {
      edges {
        node {
          frontmatter {
            title
            department
            slug
          }
          internal {
            content
          }
          html
        }
      }
    }
    footer: allMarkdownRemark(
      filter: {
        frontmatter: {
          path: { eq: "/ui" }
          published: { eq: true }
          lang: { eq: "de" }
        }
      }
    ) {
      edges {
        node {
          frontmatter {
            section
            title
            subtitle
            cta
            ctaUrl
          }
        }
      }
    }
  }
`

const PositionDetailPage = ({ data }) => {
  const content = compose(getQueryData, getEdgesForQuery("content"))(data)
  const positionDetails = compose(
    head,
    getQueryData,
    getEdgesForQuery("positionDetails")
  )(data)

  const positionTitle = prop("title", positionDetails)
  const positionDepartment = prop("department", positionDetails)
  const positionDetailsHtml = {
    __html: prop("html", positionDetails),
  }

  const headerSectionData = getSectionDataFor("careers-section-header", content)

  const footer = compose(getQueryData, getEdgesForQuery("footer"))(data)
  const contactSectionData = getSectionDataFor("ui-section-footer-apply", footer)

  return (
    <MainLayout>
      <HeaderSection data={headerSectionData} image={imageCareers} />
      <section className="position-detail d-flex">
        <Container className="my-5 py-5">
          <Row className="my-5 d-flex justify-content-center">
            <Col xs={11} sm={12} lg={10} xl={9}>
              <h5 className="text-capitalize">{positionDepartment}</h5>
            </Col>
            <Col xs={11} sm={12} lg={10} xl={9}>
              <h2>{positionTitle}</h2>
            </Col>
            <Col
              xs={11}
              sm={12}
              lg={10}
              xl={9}
              dangerouslySetInnerHTML={positionDetailsHtml}
            ></Col>
          </Row>
        </Container>
      </section>
      <ContactSection data={contactSectionData} />
    </MainLayout>
  )
}

export default PositionDetailPage
